import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'app-procedure-content-view-selector',
    templateUrl: './procedure-content-view-selector.component.html',
    styleUrls: ['./procedure-content-view-selector.component.scss'],
    standalone: false
})
export class ProcedureContentViewSelectorComponent {

  @Input() currentProcedureContentViewName: string;
  @Output() viewSelected = new EventEmitter<string>();

  readonly views = [
    {name: 'steps', labelKey: 'TRANS__FIELD__PROCEDURE_STEPS'},
    {name: 'objects', labelKey: 'TRANS__SEARCH_VIEWS__ALL_OBJECTS_ARTIFACTS'},
  ];

  selectView(viewName: string) {
    if (viewName === this.currentProcedureContentViewName) {
      return;
    }
    this.currentProcedureContentViewName = viewName;
    this.viewSelected.emit(viewName);
  }

}
